export function generateZoomInitialTables(props) {
   const tablesObj = {};
   props.forEach((prop) => (tablesObj[prop] = []));
   return tablesObj;
}
